import React from 'react';

import './CancelTradeConfirmation.scss';

import Button from '../../Shared/Button/Button';
import { CANCEL_TRADE_CONFIRMATION_MODAL } from '../../../redux/modules/modals/modals.module';

const CancelTradeConfirmation = ({ closeModal, returnURL }) => (
  <div className="cancel-trade-confirmation-container">
    <p className="cancel-trade-confirmation-modal-header">
      Are you sure you want to leave?
    </p>
    <p className="cancel-trade-confirmation-modal-sub-header">
      Leaving this page will clear any information you have entered.
    </p>
    <div className="cancel-trade-confirmation-buttons-container">
      <Button
        id="cancel-trade-stay-btn"
        type="button"
        buttonType="primary"
        onClick={() => closeModal(CANCEL_TRADE_CONFIRMATION_MODAL)}
      >
        <b>Stay on This Page</b>
      </Button>
      <a href={returnURL()} id="cancel-trade-leave">
        <b>Leave This Page</b>
      </a>
    </div>
  </div>
);

export default CancelTradeConfirmation;
